<template>
  <ContentBlocks v-bind="{ entry, product, addOn }" />
</template>

<script>
import gql from 'graphql-tag';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';
import { generateSchema as generateProductSchema } from './ProductPage.schema';
import { useAppStore } from '@/stores/app';

export const ProductPageFragment = gql`
  fragment ProductPageFragment on products_Entry {
    shopifyHandle

    agreementCategory {
      ... on preAssessment_Entry {
        title
        agreementBody
        agreementLabel
        disagreementLabel
        confirmButtonLabel
        cancelButtonLabel
      }
    }

    breadcrumbCollection {
      title
      uri
      ... on collections_Entry {
        collectionHandle
      }
    }

    productReference {
      ... on shopifyProduct_Entry {
        shopifyHandle

        sizeTableHeading
        sizeTableIntroduction
        sizeTableExplanation
        sizeTableVisual {
          url
          alt
        }
        productSizeTable {
          size
          columnOne
          columnTwo
          columnThree
          columnFour
        }
      }
    }

    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'ProductPage',
  components: {
    ContentBlocks,
  },
  props: {
    entry: {
      type: Object,
      default: () => null,
    },
    product: {
      type: Object,
      default: () => null,
    },
    addOn: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    if (props.product && props.entry) {
      const { registerComponentSchema, DEFAULT_PAGE_SCHEMA } = useSchema();
      const appStore = useAppStore();
      const siteIdentity = appStore.siteIdentity || {};

      const schema = generateProductSchema(props.product, props.entry, siteIdentity);
      registerComponentSchema(schema, DEFAULT_PAGE_SCHEMA);
    }
  },
});
</script>
